import * as React from 'react';
import { twMerge } from 'tailwind-merge';

const modifierSymbols: Record<string, string> = {
  cmd: '⌘',
  command: '⌘',
  ctrl: '⌃',
  control: '⌃',
  shift: '⇧',
  alt: '⌥',
  option: '⌥',
  meta: '⌘',
};

export interface KbdProps extends React.HTMLAttributes<HTMLElement> {
  keys?: string[];
}

export const Kbd = React.forwardRef<HTMLElement, KbdProps>(
  ({ className, keys, children, ...props }, ref) => {
    const displayKeys = keys || (typeof children === 'string' ? [children] : []);

    const renderKey = (key: string): string => {
      const lowerKey = key.toLowerCase();
      return modifierSymbols[lowerKey] || key;
    };

    return (
      <kbd
        ref={ref}
        className={twMerge(
          'inline-flex items-center gap-1 rounded border border-gray-300 bg-gray-50 px-2 py-1 font-mono text-xs font-semibold text-gray-700 shadow-sm',
          className
        )}
        {...props}
      >
        {displayKeys.map((key, index) => (
          <React.Fragment key={index}>
            {index > 0 && <span className="text-gray-400">+</span>}
            <span>{renderKey(key)}</span>
          </React.Fragment>
        ))}
        {!keys && children}
      </kbd>
    );
  }
);

Kbd.displayName = 'Kbd';
